import { render, staticRenderFns } from "./product_life_electric.vue?vue&type=template&id=76451f0d&scoped=true"
import script from "./product_life_electric.vue?vue&type=script&lang=js"
export * from "./product_life_electric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76451f0d",
  null
  
)

export default component.exports